export default __webpack_public_path__ + "static/media/happyTeamsTool.dc213aa4.png";